import _ from 'lodash';
import axios from 'axios';
import moment from 'moment';

export default {
  props: {
    url: { type: String, required: true },
    mes_salida: { type: String, required: false },
    ciudad_salida: { type: String, required: false },
    ciudades: { type: Array, required: false, default() { return []; } },
    proveedores: { type: Array, required: false, default() { return []; } },
    isAdmin: { type: Boolean, required: false, default: false },
    showConectores: { type: Boolean, required: false, default: true },
  },
  data() {
    return {
      mes: this.mes_salida,
      salida: this.ciudad_salida,
      destino: this.ciudades,
      proveedor: this.proveedores,
      preloader: true,

      meses: [],
      salidas: [],
      destinos: [],
      conectores: [],
    };
  },
  async created() {
    await this.getData(true);
  },
  methods: {
    async getData() {

      this.preloader = true;

      const response = await axios.get(`${this.url}/services/circuitos/filtros`, {
        params: {
          mes: this.mes,
          origen: this.salida,
          destino: this.destino,
          conector: this.proveedor
        }
      });

      const filtros = response.data;

      this.meses = filtros.meses;
      this.salidas = filtros.origenes;
      this.destinos = filtros.destinos;
      this.conectores = filtros.conectores;

      this.preloader = false;

    },
    reduce(item) { return item.id; }
  },
  computed: {

    isBTN() { return !!(this.mes); },
    urlAction() { return this.url + '/services/circuitos'; },

    isMeses() { return this.meses.length > 0; },
    isSalidas() { return this.salidas.length > 0; },
    isDestinos() { return this.destinos.length > 0; },
    isConectores() { return this.conectores.length > 0; },

    params() {
      return {
        mes_salida: this.mes ? this.mes : '',
        ciudad_salida: this.salida ? this.salida : '',
        ciudades: this.destino,
        proveedores: this.proveedor
      };
    }
  },
  watch: {
    async mes() {
      await this.getData();
    },
    async salida() {
      await this.getData();
    },
    async destino() {
      await this.getData();
    },
    async proveedor() {
      await this.getData();
    }
  }
};
